// //*direct code
// import React, { useState } from 'react';
// import './TableViewFormate.css'; // Import your custom CSS file
// import WebcamCapture from './WebcamCapture';
// import { useMain } from '../hooks/useMain';
// import ShowLoader from 'src/components/CustomComponents/ShowLoader';

// const TableViewFormate = ({ data, getAttendance }) => {
//   const [appointments, setAppointments] = useState([]);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isAppointmentDrawerOpen, setIsAppointmentDrawerOpen] = useState(false);
//   const [todayAttendance, setTodayAttendance] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [isWebcamOpen, setIsWebcamOpen] = useState(false);
//   const [capturedimages, setCapturedimages] = useState('');
//   const [imagePreview, setImagePreview] = useState(null);
//   const [punchInTime, setPunchInTime] = useState(''); // Track punch-in time
//   const [punchAction, setPunchAction] = useState(''); // Track punch action (in or out)

//   const { createAttandence, branchId, activeStaffId, fetchStaffAppointmentsDateWise } = useMain();

//   const openAppointmentDrawer = (date) => {
//     getAppointments(activeStaffId, date);
//     setIsAppointmentDrawerOpen(true);
//   };

//   const handleModalOpen = (attendance, action) => {
//     setIsModalOpen(true);
//     setTodayAttendance((prev) => ({ ...prev, ...attendance }));
//     setPunchAction(action);

//     if (action === 'in') {
//       setIsWebcamOpen(true); // Open webcam for Punch In
//     }
//   };

//   const handleModalClose = () => {
//     setIsModalOpen(false);
//     setIsWebcamOpen(false);
//     setCapturedimages(''); // Reset captured image on modal close
//     setImagePreview(null);
//     setPunchInTime(''); // Reset punch-in time
//     setPunchAction(''); // Reset punch action
//   };

//   const handleAttendanceSubmit = async (staffId, branchId) => {
//     try {
//       setIsModalOpen(false);
//       if (punchAction === 'in' && !capturedimages) {
//         return alert('Please capture your selfie before punching in.');
//       }
//       const formData = new FormData();
//       if (capturedimages) {
//         formData.append('images', capturedimages);
//       }
//       formData.append('branchId', branchId);
//       const res = await createAttandence(staffId, formData);
//       if (res.statusCode === 200) {
//         getAttendance(staffId);
//       }
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   const handleImagesCapture = (images, preview) => {
//     setImagePreview(preview);
//     setCapturedimages(images);
//     setPunchInTime(getTime()); // Capture the punch-in time here
//     setIsWebcamOpen(false); // Close webcam after capturing the image
//   };

//   const renderAttendance = (date, attendance) => {
//     const newDate = new Date();
//     const day = newDate.getDate();
//     const month = newDate.getMonth() + 1;
//     const year = newDate.getFullYear();
//     const formattedDate = `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day}`;

//     const isPresent = attendance.remarkTick || false;
//     const outTiming = attendance.date === date && attendance.outTime !== '';
//     const isToday = date === formattedDate;

//     return isToday && !isPresent ? (
//       <button className="btn btn-primary" onClick={() => handleModalOpen(attendance, 'in')}>
//         Punch In
//       </button>
//     ) : isToday && !outTiming ? (
//       <div className="attendance-status">
//         <p className={`status-text ${isPresent ? 'present' : 'absent'}`}>{isPresent ? 'Present' : 'Absent'}</p>
//         <button className="btn btn-primary" onClick={() => handleModalOpen(attendance, 'out')}>
//           Punch Out
//         </button>
//       </div>
//     ) : (
//       <p className={`status-text ${isPresent ? 'present' : 'absent'}`}>{isPresent ? 'Present' : 'Absent'}</p>
//     );
//   };

//   const getAppointments = async (activeStaffId, date) => {
//     const queryParams = `?staffId=${activeStaffId}&date=${date}&branchId=${branchId}`;
//     try {
//       setLoading(true);
//       const res = await fetchStaffAppointmentsDateWise(queryParams);
//       if (res.statusCode === 200) {
//         setAppointments(res.data);
//       } else {
//         setAppointments([]);
//       }
//     } catch (error) {
//       setAppointments([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="table-wrapper">
//       <table className="table-container">
//         <thead>
//           <tr>
//             {['Date', 'Day', 'Attendance', 'Appointments'].map((header, index) => (
//               <th key={index}>{header}</th>
//             ))}
//           </tr>
//         </thead>
//         <tbody>
//           {data.map((item, index) => (
//             <tr key={index} className="table-row-wrapper">
//               <td>{item.date}</td>
//               <td>{item.day}</td>
//               <td>{renderAttendance(item.date, item.attendance)}</td>
//               <td>
//                 <button className="btn btn-primary" onClick={() => openAppointmentDrawer(item.date)}>
//                   Appointments
//                 </button>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>

//       {/* Modal */}
//       <div className={`modal ${isModalOpen ? 'modal-open' : ''}`}>
//         <div className="modal-content">
//           <h2>{punchAction === 'in' ? 'Punch In' : 'Punch Out'}</h2>
//           {punchAction === 'in' && isWebcamOpen ? (
//             <WebcamCapture onCapture={handleImagesCapture} />
//           ) : punchAction === 'in' ? (
//             <>
//               <p>Punch In Time: {punchInTime && convertTo12HourFormat(punchInTime)}</p>
//               {capturedimages && (
//                 <>
//                   <img src={imagePreview} alt="Captured" className="captured-image" />
//                   <button style={{marginTop:"1rem",marginBottom:"1rem"}} className="btn btn-secondary" onClick={() => setIsWebcamOpen(true)}>
//                     Retake
//                   </button>
//                 </>
//               )}
//             </>
//           ) : (
//             <p>Punch Out Time: {convertTo12HourFormat(getTime())}</p>
//           )}
//           <div className="modal-actions">
//             <button className="btn btn-secondary" onClick={handleModalClose}>
//               No
//             </button>
//             <button className="btn btn-primary" onClick={() => handleAttendanceSubmit(activeStaffId, branchId)}>
//               Yes
//             </button>
//           </div>
//         </div>
//       </div>

//       {/* Drawer */}
//       <div className={`drawer ${isAppointmentDrawerOpen ? 'drawer-open' : ''}`}>
//         {loading ? (
//           <ShowLoader />
//         ) : (
//           <div className="drawer-content">
//             <h2>Appointment Details</h2>
//             {appointments.length > 0 ? (
//               appointments.map((appointment, index) => (
//                 <div key={index}>
//                   <div>Client Name: {appointment.clientName}</div>
//                   <div>Date: {appointment.dateOfAppointment}</div>
//                   <div>Service: {appointment.serviceSelected.service.serviceName}</div>
//                   <div>Time Of Appointment: {appointment.timeOfAppointment}</div>
//                   {index < appointments.length - 1 && <hr />}
//                 </div>
//               ))
//             ) : (
//               <div>No appointments selected.</div>
//             )}
//             <button className="btn btn-secondary" onClick={() => setIsAppointmentDrawerOpen(false)}>
//               Close
//             </button>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default TableViewFormate;

// function convertTo12HourFormat(timeStr) {
//   const [hours, minutes] = timeStr.split(':').map(Number);
//   const period = hours >= 12 ? 'PM' : 'AM';
//   const formattedHours = hours % 12 || 12;
//   return `${formattedHours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')} ${period}`;
// }
// function getTime() {
//   const utcNow = new Date();
//   const istOptions = { timeZone: 'Asia/Kolkata', hour: '2-digit', minute: '2-digit', hour12: false };
//   const istNow = new Intl.DateTimeFormat('en-US', istOptions).format(utcNow);
//   return istNow;
// }

import React, { useState } from 'react';
import './TableViewFormate.css';
import WebcamCapture from './WebcamCapture';
import { useMain } from '../hooks/useMain';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';

const TableViewFormate = ({ data, getAttendance }) => {
  const [appointments, setAppointments] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAppointmentDrawerOpen, setIsAppointmentDrawerOpen] = useState(false);
  const [todayAttendance, setTodayAttendance] = useState({});
  const [loading, setLoading] = useState(false);
  const [isWebcamOpen, setIsWebcamOpen] = useState(false);
  const [capturedimages, setCapturedimages] = useState('');
  const [imagePreview, setImagePreview] = useState(null);
  const [punchInTime, setPunchInTime] = useState('');
  const [punchAction, setPunchAction] = useState('');
  const [submitLoading, setSubmitLoading] = useState(false);

  const { createAttandence, branchId, activeStaffId, fetchStaffAppointmentsDateWise } = useMain();

  const openAppointmentDrawer = (date) => {
    getAppointments(activeStaffId, date);
    setIsAppointmentDrawerOpen(true);
  };

  const handleModalOpen = (attendance, action) => {
    setIsModalOpen(true);
    setTodayAttendance((prev) => ({ ...prev, ...attendance }));
    setPunchAction(action);

    if (action === 'in') {
      setIsWebcamOpen(true);
    }
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setIsWebcamOpen(false);
    setCapturedimages('');
    setImagePreview(null);
    setPunchInTime('');
    setPunchAction('');
  };

  // const handleAttendanceSubmit = async (staffId, branchId) => {
  //   try {
  //     setIsModalOpen(false);
  //     if (punchAction === 'in' && !capturedimages) {
  //       return alert('Please capture your selfie before punching in.');
  //     }
  //     const formData = new FormData();
  //     if (capturedimages) {
  //       formData.append('images', capturedimages);
  //     }
  //     formData.append('branchId', branchId);
  //     const res = await createAttandence(staffId, formData);
  //     if (res.statusCode === 200) {
  //       getAttendance(staffId);
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  const handleAttendanceSubmit = async (staffId, branchId) => {
    try {
      if (punchAction === 'in' && !capturedimages) {
        return alert('Please capture your selfie before punching in.');
      }

      setSubmitLoading(true); // 🔵 Start loader

      setIsModalOpen(false);

      const formData = new FormData();
      if (capturedimages) {
        formData.append('images', capturedimages);
      }
      formData.append('branchId', branchId);

      const res = await createAttandence(staffId, formData);
      if (res.statusCode === 200) {
        getAttendance(staffId);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setSubmitLoading(false); // 🔴 Stop loader
    }
  };


  const handleImagesCapture = (images, preview) => {
    setImagePreview(preview);
    setCapturedimages(images);
    setPunchInTime(getTime());
    setIsWebcamOpen(false);
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const [year, month, day] = dateStr.split('-');
    return `${day}-${month}-${year}`;
  };

  const renderStatus = (date, attendance) => {
    const newDate = new Date();
    const day = newDate.getDate();
    const month = newDate.getMonth() + 1;
    const year = newDate.getFullYear();
    const formattedDate = `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day}`;

    const status = attendance.status || 'Absent';
    const outTiming = attendance.date === date && attendance.outTime !== '';
    const isToday = date === formattedDate;

    // Get the appropriate color class based on status
    const getStatusColor = () => {
      switch (status) {
        case 'Present': return { color: 'green' };
        case 'Absent': return { color: 'red' };
        case 'Halfday': return { color: '#FFB001' };
        case 'Week Off': return { color: '#2668F4' };
        default: return { color: 'black' };
      }
    };

    if (isToday && status === 'Absent') {
      return (
        <button className="btn btn-primary" onClick={() => handleModalOpen(attendance, 'in')}>
          Punch In
        </button>
      );
    } else if (isToday && !outTiming && status === 'Present') {
      return (
        <div className="attendance-status">
          <span className="status-text" style={getStatusColor()}>{status}</span>
          <button className="btn btn-primary" onClick={() => handleModalOpen(attendance, 'out')}>
            Punch Out
          </button>
        </div>
      );
    } else {
      return <span className="status-text" style={getStatusColor()}>{status}</span>;
    }
  };

  const getAppointments = async (activeStaffId, date) => {
    const queryParams = `?staffId=${activeStaffId}&date=${date}&branchId=${branchId}`;
    try {
      setLoading(true);
      const res = await fetchStaffAppointmentsDateWise(queryParams);
      if (res.statusCode === 200) {
        setAppointments(res.data);
      } else {
        setAppointments([]);
      }
    } catch (error) {
      setAppointments([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="table-wrapper">
      <table className="table-container">
        <thead>
          <tr>
            {[
              'Date',
              'Day',
              'In Time',
              'Out Time',
              'Status',
              'Effective Hours',
              'Appointments',
            ].map((header, index) => (
              <th key={index}>{header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr key={index} className="table-row-wrapper">
              <td>{formatDate(item.date)}</td>
              <td>{item.day}</td>
              <td>
                {item.attendance.inTime ? (item.attendance.inTime) : '--:--'}
              </td>
              <td>
                {item.attendance.outTime ? (item.attendance.outTime) : '--:--'}
              </td>
              <td>{renderStatus(item.date, item.attendance)}</td>
              <td>{item.effectiveWorkInHours}</td>
              <td>
                <button
                  className="btn btn-primary"
                  onClick={() => openAppointmentDrawer(item.date)}
                >
                  Appointments
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Modal */}
      <div className={`modal ${isModalOpen ? 'modal-open' : ''}`}>
        <div className="modal-content">
          <h2>{punchAction === 'in' ? 'Punch In' : 'Punch Out'}</h2>
          {punchAction === 'in' && isWebcamOpen ? (
            <WebcamCapture onCapture={handleImagesCapture} />
          ) : punchAction === 'in' ? (
            <>
              <p>Punch In Time: {punchInTime && convertTo12HourFormat(punchInTime)}</p>
              {capturedimages && (
                <>
                  <img src={imagePreview} alt="Captured" className="captured-image" />
                  <span style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
                    <button
                      style={{
                        marginTop: '1rem',
                        marginBottom: '0rem',
                        width: '100px',
                        height: '40px',
                        background: '#dc3545',
                      }}
                      className="btn btn-secondary"
                      onClick={() => setIsWebcamOpen(true)}
                    >
                      Retake
                    </button>
                    <button
                      className="btn btn-primary"
                      onClick={() => handleAttendanceSubmit(activeStaffId, branchId)}
                      disabled={submitLoading}
                      style={{
                        marginTop: '1rem',
                        marginBottom: '0rem',
                        width: '100px',
                        height: '40px',
                      }}
                    >
                      {submitLoading ? 'Submitting...' : 'Submit'}
                    </button>
                  </span>
                </>
              )}
            </>
          ) : (
            <p>Punch Out Time: {convertTo12HourFormat(getTime())}</p>
          )}
          {punchAction === 'out' && (
            <div className="modal-actions">
              <button
                className="btn btn-secondary"
                onClick={handleModalClose}
                disabled={submitLoading}
              >
                No
              </button>
              <button
                className="btn btn-primary"
                onClick={() => handleAttendanceSubmit(activeStaffId, branchId)}
                disabled={submitLoading}
              >
                {submitLoading ? 'Submitting...' : 'Yes'}
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Drawer */}
      <div className={`drawer ${isAppointmentDrawerOpen ? 'drawer-open' : ''}`}>
        {loading ? (
          <ShowLoader />
        ) : (
          <div className="drawer-content">
            <h2>Appointment Details</h2>
            {appointments.length > 0 ? (
              appointments.map((appointment, index) => (
                <div key={index}>
                  <div>Client Name: {appointment.clientName}</div>
                  <div>Date: {formatDate(appointment.dateOfAppointment)}</div>
                  <div>Service: {appointment.serviceSelected.service.serviceName}</div>
                  <div>Time Of Appointment: {appointment.timeOfAppointment}</div>
                  {index < appointments.length - 1 && <hr />}
                </div>
              ))
            ) : (
              <div>No appointments selected.</div>
            )}
            <button className="btn btn-secondary" onClick={() => setIsAppointmentDrawerOpen(false)}>
              Close
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default TableViewFormate;

function convertTo12HourFormat(timeStr) {
  if (!timeStr) return '--:--';
  const [hours, minutes] = timeStr.split(':').map(Number);
  const period = hours >= 12 ? 'PM' : 'AM';
  const formattedHours = hours % 12 || 12;
  return `${formattedHours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')} ${period}`;
}

function getTime() {
  const utcNow = new Date();
  const istOptions = { timeZone: 'Asia/Kolkata', hour: '2-digit', minute: '2-digit', hour12: false };
  const istNow = new Intl.DateTimeFormat('en-US', istOptions).format(utcNow);
  return istNow;
}
